<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <div class="va-card">
        <div class="va-card__header-inner">
          <div class="va-card__header-title" style="color: rgb(44, 130, 224);"> {{ $t('events.addNewLocation') }} </div>
        </div>
        <div class="va-card__body">
          <form @submit.prevent="onsubmit()">
            <div class="row">
              <va-input
                v-model="name"
                type="text"
                :label="$t('events.modal.eventName')"
                :error="!!nameErrors.length"
                :error-messages="nameErrors"
                class="flex xs12 sm12 md12 lg12 xl12"
              />

              <div class="flex xs12">
                <div class="row">
                  <div class="flex xs4">
                    {{ $t('events.modal.openFrom') }}: <vue-timepicker
                      v-model="openHour"
                      :minute-interval="10"
                    />
                  </div>

                  <div class="flex xs4">
                    {{ $t('events.modal.closeOn') }}: <vue-timepicker
                      v-model="closeHour"
                      :minute-interval="10"
                    />
                  </div>
                  <div class="flex xs12">{{ $t('events.modal.leaveHours') }}</div>
                  <div class="flex xs12" v-if="!!openCloseHourErrors.length" style="color: crimson;"> {{openCloseHourErrors[0]}}</div>
                </div>
              </div>

              <div class="flex xs12">
                <fieldset>
                  <va-checkbox
                    :label="$t('events.modal.temporaryLocation')"
                    v-model="isValet"
                  />
                </fieldset>
              </div>

              <div class="flex xs12">
                <fieldset>
                  <va-checkbox
                    :label="$t('events.modal.addAddress')"
                    v-model="needAddress"
                  />
                </fieldset>
              </div>

              <div class="flex xs12">
                <div v-if="needAddress" class="row">
                  <va-input
                    v-model="inputAddress"
                    type="text"
                    :label="$t('events.modal.address')"
                    :error="!!addressErrors.length"
                    :error-messages="addressErrors"
                    class="flex xs9 sm9 md9 lg9 xl9"
                  />
                  <div class="flex xs3 sm3 md3 lg3 xl3">
                    <va-button @click="onsearch" class="my-0">{{ $t('events.modal.searchForAddress') }}</va-button>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="showNoResults && needAddress">
              {{ $t('events.noResultsFound') }}
            </div>
            <div v-if="locations.length > 0 && needAddress">
              <va-list fit>
                <va-list-label>
                  {{ $t('events.results') }} ...
                </va-list-label>
                <va-item v-for="location in locations" v-bind:key="location.osm_id" @click="onselect(location)">
                  <va-item-section side>
                    <va-icon name="fa fa-map-marker" color="red" />
                  </va-item-section>

                  <va-item-section class="toItem">
                    <va-item-label>{{location.display_name}}</va-item-label>
                  </va-item-section>
                </va-item>
              </va-list>
              <div class="locationNote">
                {{ $t('events.moveTheMarker') }}
              </div>
            </div>
            <va-card v-if="!this.$store.getters.isLoading && needAddress"
              class="leaflet-maps-page__widget"
              :error="!!latlngErrors.length"
              :error-messages="latlngErrors"
            >
              <Map :location="latlng" style="height: 65vh;" />
            </va-card>

            <div class="d-flex justify--center mt-3">
              <va-button type="submit" class="my-0">{{ $t('events.createLocation') }}</va-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import Map from '../events/Map'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  components: { SwappingSquaresSpinner, Map, VueTimepicker },
  mixins: [errorHandlerMixin],
  name: 'NewLocation',
  data () {
    return {
      inputAddress: '',
      name: '',
      nameErrors: [],
      addressErrors: [],
      locations: [],
      latlngErrors: [],
      openCloseHourErrors: [],
      isValet: true,
      openHour: '',
      closeHour: '',
      showNoResults: false,
      needAddress: false,
      marker: {},
      address: [],
      latlng: {
        lat: undefined,
        lng: undefined,
      },
    }
  },
  methods: {
    async onselect (location) {
      this.latlng.lat = Number.parseFloat(location.lat)
      this.latlng.lng = Number.parseFloat(location.lon)
      this.$store.commit('set_current_address', this.latlng)
    },
    async onsearch () {
      this.addressErrors = this.inputAddress ? [] : [this.$t('events.completeAddress')]
      if (this.addressErrors.length) {
        return
      }
      this.showNoResults = false
      this.$store.commit('setLoading', true)
      await this.fetchAddress()
    },
    async onsubmit () {
      this.nameErrors = this.name ? [] : [this.$t('events.completeAddress')]
      if (this.nameErrors.length) {
        return
      }

      if (this.needAddress) {
        this.addressErrors = this.inputAddress ? [] : [this.$t('events.completeAddress')]
        if (this.addressErrors.length) {
          return
        }
        if (this.$store.getters.currentAddress.lat === undefined || this.$store.getters.currentAddress.lng === undefined) {
          this.latlngErrors = [this.$t('events.selectPosition')]
          return
        }
      }

      if (this.openHour || this.closeHour) {
        if (!this.openHour || !this.closeHour) {
          this.openCloseHourErrors = [this.$t('events.requiredBothTimes')]
          return
        }
      }
      this.$store.commit('setLoading', true)
      this.$store.dispatch('createLocation', {
        name: this.name,
        isValet: this.isValet,
        openHour: this.openHour,
        closeHour: this.closeHour,
        latitude: this.$store.getters.currentAddress.lat,
        longtitude: this.$store.getters.currentAddress.lng,
        address: this.inputAddress,
        isAddress: this.needAddress,
      }).then(() => this.$router.push({ name: 'locations' })).catch(err => this.errorHandler(err.response))
    },
    async initLocation () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.addresses)
      if (this.locations.length === 0) {
        this.showNoResults = true
      }
      this.$store.commit('setLoading', false)
    },
    async fetchAddress () {
      this.$store.dispatch('getAddress', this.inputAddress)
        .then(() => this.initLocation())
        .catch((err) => this.errorHandler(err.response))
    },
  },
  computed: {},
  mounted () {
  },
  created () {
    this.$store.commit('setLoading', true)
    this.latlng.lat = '41.32306'
    this.latlng.lng = '19.44139'
    this.$store.commit('setLoading', false)
  },
}
</script>

<style lang="scss">
  @import "~leaflet/dist/leaflet.css";

  .toItem:hover {
    cursor: pointer;
  }

  .locationNote {
    margin-top: 20px;
  }
</style>
